<script>
export default {
  name: "ResetConfirmDialog",
  props: {
    modelValue: {
      type: Boolean,
      default: false
    }
  },
  emits: ["update:modelValue", "confirm", "cancel"],
  methods: {
    onCancel() {
      this.$emit("cancel")
    },
    onConfirm() {
      this.$emit("confirm")
    }
  }
}
</script>

<template>
  <q-dialog :model-value="modelValue" @update:model-value="$emit('update:modelValue', $event)">
    <q-card class="confirm-modal">
      <q-card-section class="q-pb-sm">
        <div class="text-h6">초기화 확인</div>
      </q-card-section>
      <q-card-section class="q-pt-none">
        현재 진행 중인 포장 화면 상태를 초기화할까요?
      </q-card-section>
      <q-card-actions align="right" class="q-pa-md q-pt-none">
        <q-btn flat label="취소" @click="onCancel" />
        <q-btn color="red" label="초기화 실행" @click="onConfirm" />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<style scoped lang="scss">
.confirm-modal {
  width: 420px;
  max-width: 92vw;
}
</style>
